import React from 'react';
import { GridContainer, Grid } from '../../../shared/grid';
import '../FieldSample.scss';
import Button from '@mui/material/Button';

type SubmitSampleProps = {
    allFunctionsFromFieldSampleChild: any
}

export const Delete: React.FC<SubmitSampleProps> = ({ allFunctionsFromFieldSampleChild}) => {
    const handleDeleteButton = () =>{
        allFunctionsFromFieldSampleChild.setOpen(!allFunctionsFromFieldSampleChild.open); 
        allFunctionsFromFieldSampleChild.setDeletePressed(true);
    }

    const handleCancelButton = ()=>{
        allFunctionsFromFieldSampleChild.setOpen(!allFunctionsFromFieldSampleChild.open);
        if(allFunctionsFromFieldSampleChild.typeToDelete===('subsample')){
            allFunctionsFromFieldSampleChild.setSubSampleIdToDelete(null);
        }
        else{
            allFunctionsFromFieldSampleChild.setSampleToDelete(null);
        }
        allFunctionsFromFieldSampleChild.setTypeToDelete('');

    }
    return (
        <GridContainer className="removePadding">
            <Grid row gap="md" className='page-heading'>
                <Grid
                    desktop={{ col: 12 }}
                    className="display-flex flex-row flex-align-center flex-justify margin-bottom-205 paddingForModal">
                        {allFunctionsFromFieldSampleChild.archivedVerbiage?
                            (
                                <span className="font-sans-lg text-bold">Archive?</span>
                            ):(
                                <span className="font-sans-lg text-bold">Delete?</span>
                            )    
                        }
                </Grid>
            </Grid>
            <hr style={{ width: '100%', marginBottom: 0 }}></hr>
                {allFunctionsFromFieldSampleChild.archivedVerbiage?
                (
                    <Grid row className="paddingForm2">
                       {allFunctionsFromFieldSampleChild.typeToDelete===('subsample')? `Are you sure you want to archive this sub-sample?`:`Are you sure you want to archive this sample?` }
                    </Grid>
                ):(
                    <Grid row className="paddingForm2">
                      Are you sure you want to delete this item? This will be a permanent delete from the system.
                    </Grid>
                )    
                }

            <Grid row className='modalBottomDiv'>
                <Grid desktop={{ col: 9 }} className="modalCancelDiv">
                    <Button variant="outlined" style={{ backgroundColor: 'white',textTransform: 'none' }} onClick={() => { handleCancelButton()}}>
                        Cancel
                    </Button>
                </Grid>
                <Grid desktop={{ col: 3 }} className='modalSubmitDiv'>
                {allFunctionsFromFieldSampleChild.archivedVerbiage?
                    (
                    <Button color="error" variant="contained" type="submit" style={{textTransform: 'none'}} onClick={() => { handleDeleteButton() }}>
                        Archive
                    </Button>
                    ):(
                    <Button color="error" variant="contained" type="submit" style={{textTransform: 'none'}} onClick={() => { handleDeleteButton() }}>
                        Delete
                    </Button>
                    )    
                }
                </Grid>
            </Grid>
        </GridContainer>
    )
}